import { RouteMapItem } from "types";
import getRouteFromPath from "routing/getRouteFromPath";
import { toObject } from "@civicscience/chops";

/**
 *
 * @param path {string}
 * @param routeMap {[{path:string, title:string}]}
 * @returns {null|string}
 */
type getTitleFromRouteProps = {
  path: string;
  routeMap: RouteMapItem[];
};

const getTitleFromRoute = ({ path = "", routeMap = [] }: getTitleFromRouteProps): string | JSX.Element | undefined => {
  const routeFromPath = getRouteFromPath({ path, routeMap });
  const { title, longTitle } = toObject(routeFromPath);
  //Return longTitle as primary and title as secondary
  return longTitle || title;
};

export default getTitleFromRoute;
